import { createStore } from "redux";
import rootReducer from "redux/reducers";
import { devToolsEnhancer } from "@redux-devtools/extension";

export default createStore(rootReducer, devToolsEnhancer());
